import { dataUserSyncSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserSyncSolid = /*#__PURE__*/createIcon(dataUserSyncSolid)
export default IconUserSyncSolid
